function createAction(name) {
  return `@@formPropertyNavigation/${name}`;
}
export const UPDATE_PROPERTY_NAVIGATION_TAB = createAction('UPDATE_PROPERTY_NAVIGATION_TAB');
export function updatePropertyNavigationTab(tab) {
  return {
    type: UPDATE_PROPERTY_NAVIGATION_TAB,
    tab
  };
}